export default "__VITE_ASSET__BzoAxxtP__"